<!-- <div class="form-field-wrapper"> -->
<mat-form-field
  appearance="outline"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    "region.title" | translate
  }}</mat-label>
  <mat-select [formControl]="control">
    <!-- Allow deselect -->
    <mat-option [value]="null">- -</mat-option>

    <!-- Trigger -->
    <mat-select-trigger *ngIf="control.value">
      {{ getSelectedRegion() }}
    </mat-select-trigger>

    <!-- Options -->
    <mat-option *ngFor="let region of REGIONS" [value]="region">
      {{ region }}
    </mat-option>
  </mat-select>

  <mat-error *ngIf="control.invalid && control.touched && required">
    {{ "region.required" | translate }}
  </mat-error>
</mat-form-field>
<!-- </div> -->
